const KEY_L = 76;

let isInitialized = false;

export function initializeLoginKeyRedirect(redirectUrl: string): void {
  if (!isInitialized) {
    isInitialized = true;
    window.addEventListener('keyup', function (event) {
      if (event.ctrlKey && event.altKey && event.shiftKey) {
        if (event.which === KEY_L) {
          window.location.href = redirectUrl;
        }
      }
    });
  }
}
